"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _state = require("@seedlang/state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var FeedEntryIndexWrapper = function FeedEntryIndexWrapper(Component) {
  var _class;
  return (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _callSuper(this, _class, [props]);
      _this.mounted = false;
      _this.skipNextFocusReload = true;
      _this.requestSequence = 0;
      _this.unsubscribeFocusListener = null;
      _this.onDestroyFeedEntry = function (id) {
        _state.AppUI.feedEntryStore.destroy({
          ids: {
            feedEntryId: id
          }
        }, _this.getFeedEntryIndex);
      };
      _this.afterGetFeedEntryIndex = function (requestKey) {
        return function (resp) {
          if (_this.mounted && _this.activeRequestKey === requestKey) {
            _state.AppUI.feedEntryStore.afterGetIndex(resp);
          }
        };
      };
      _this.onFocus = function () {
        if (_this.skipNextFocusReload) {
          _this.skipNextFocusReload = false;
          return;
        }
        _this.getFeedEntryIndex();
      };
      _this.getFeedEntryIndex = function () {
        var requestKey = "".concat(_this.requestFeedEntryIndexKey, "-").concat(_this.requestSequence += 1);
        _this.activeRequestKey = requestKey;
        _state.AppUI.feedEntryStore.clearIndexData();
        if (_this.props.user && _this.props.show === 'my.feed') {
          _state.AppUI.feedEntryStore.setFilter('user_id', _this.props.user.id);
          _state.AppUI.feedEntryStore.reloadIndexFiltered({
            callback: _this.afterGetFeedEntryIndex(requestKey)
          });
        } else {
          _state.AppUI.feedEntryStore.clearFilter();
          _state.AppUI.feedEntryStore.getIndex(null, _this.afterGetFeedEntryIndex(requestKey));
        }
      };
      _this.afterChange = function () {
        _state.AppUI.feedEntryStore.reloadIndexFiltered();
      };
      _state.AppUI.feedEntryStore.setLimit(5);
      return _this;
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$navigatio;
        this.mounted = true;
        this.getFeedEntryIndex();
        if ((_this$props$navigatio = this.props.navigation) !== null && _this$props$navigatio !== void 0 && _this$props$navigatio.addListener) {
          this.unsubscribeFocusListener = this.props.navigation.addListener('focus', this.onFocus);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show || this.props.user !== prevProps.user) {
          this.getFeedEntryIndex();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
        this.unsubscribeFocusListener && this.unsubscribeFocusListener();
      }
    }, {
      key: "requestFeedEntryIndexKey",
      get: function get() {
        var _this$props$user;
        return "".concat(this.props.show || 'all', "-").concat(((_this$props$user = this.props.user) === null || _this$props$user === void 0 ? void 0 : _this$props$user.id) || 'all');
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          feedEntries: _state.AppUI.feedEntryStore.indexData,
          onDestroyFeedEntry: this.onDestroyFeedEntry,
          afterChange: this.afterChange
        }));
      }
    }]);
  }(_react["default"].Component)) || _class;
};
FeedEntryIndexWrapper.displayName = 'FeedEntryIndexWrapper';
var _default = exports["default"] = FeedEntryIndexWrapper;